import { render, staticRenderFns } from "./MobileCommunityHealthInfoDetail.vue?vue&type=template&id=5cd73096&scoped=true&"
import script from "./MobileCommunityHealthInfoDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityHealthInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityHealthInfoDetail.vue?vue&type=style&index=0&id=5cd73096&scoped=true&lang=css&"
import style1 from "./MobileCommunityHealthInfoDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd73096",
  null
  
)

export default component.exports